import { Calendar, GregorianCalendar } from '@internationalized/date';

/* Ref: https://react-spectrum.adobe.com/react-aria/useDateField.html#reducing-bundle-size */
export const createCalendar = (identifier: string): Calendar => {
    switch (identifier) {
        case 'gregory':
            return new GregorianCalendar();
        default:
            throw new Error(`Unsupported calendar ${identifier}`);
    }
};
